import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import translationEN from './locales/en.json';
import translationES from './locales/es.json';
import translationCA from './locales/ca.json';
import translationFR from './locales/fr.json';

const resources = {
  en: {
    translation: translationEN
  },
  es: {
    translation: translationES
  },
  ca: {
    translation: translationCA
  },
  fr: {
    translation: translationFR
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    },
    supportedLngs: ['es', 'ca', 'en', 'fr'],
    nonExplicitSupportedLngs: true,
    // El idioma lo marca la URL: /ca/..., /en/..., /fr/... (sin prefijo = español)
    detection: {
      order: ['path'],
      lookupFromPathIndex: 0,
      caches: []
    }
  });

export default i18n;